// ブラウザ側でユーザーの位置情報を取得しurlクエリに追加する。
// wordpress/wp-content/themes/wprt-theme/inc/archive-sort.phpで利用する

document.addEventListener('DOMContentLoaded', () => {
  const nearSortButton = document.getElementById(
    'near'
  ) as HTMLAnchorElement | null;

  if (!nearSortButton) return;

  nearSortButton.addEventListener('click', async (event) => {
    event.preventDefault(); // デフォルトのページ遷移を防ぐ

    if (!navigator.geolocation) {
      alert('お使いのブラウザでは位置情報がサポートされていません。');
      return;
    }

    try {
      // 位置情報の許可状態を確認
      const permissionStatus = await navigator.permissions.query({
        name: 'geolocation',
      });

      if (permissionStatus.state === 'granted') {
        // すでに許可済み → 位置情報を取得
        getLocationAndRedirect(nearSortButton);
      } else if (permissionStatus.state === 'prompt') {
        // ユーザーに許可を求める（ブラウザのポップアップが出る）
        navigator.geolocation.getCurrentPosition(
          () => {
            // 許可されたらリダイレクト
            getLocationAndRedirect(nearSortButton);
          },
          (error) => {
            // 拒否された場合
            handleGeolocationError(error);
          }
        );
      } else {
        // すでに拒否済みの場合
        alert(
          '位置情報の取得が許可されていません。「近い順」の表示ができません。'
        );
      }
    } catch (error) {
      console.error('位置情報の許可状態の確認に失敗しました', error);
      alert('位置情報の取得に失敗しました。ブラウザの設定を確認してください。');
    }
  });
});

/**
 * 位置情報を取得してページ遷移する
 */
function getLocationAndRedirect(button: HTMLAnchorElement) {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      // URLのクエリパラメータを更新
      const url = new URL(button.href);
      url.searchParams.set('lat', String(lat));
      url.searchParams.set('lng', String(lng));

      // ページ遷移
      window.location.href = url.toString();
    },
    (error) => {
      handleGeolocationError(error);
    }
  );
}

/**
 * 位置情報の取得エラーを処理
 */
function handleGeolocationError(error: GeolocationPositionError) {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      alert(
        '位置情報の取得が許可されていません。「近い順」の表示ができません。'
      );
      break;
    case error.POSITION_UNAVAILABLE:
      alert('位置情報が利用できません。');
      break;
    case error.TIMEOUT:
      alert('位置情報の取得がタイムアウトしました。');
      break;
    default:
      alert('位置情報の取得中にエラーが発生しました。');
  }
}
